import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { PaginationLimit } from 'src/app/core/constants/dropdown-contants';
import { CacheAgentService } from './services/cache-agent.service';
import { el } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-agent-company-dropdown',
  templateUrl: './agent-company.component.html',
  styleUrls: ['./agent-company.component.scss']
})
export class AgentCompanyComponent implements OnInit, OnChanges {
  @Input() control: FormControl = new FormControl('');
  @Input() label: string = 'agent';
  @Input() placeholder: string = 'Select agent';
  @Input() selectedagent: string | string[] = '';
  @Input() showAllagent: boolean = false;
  @Input() agentName: boolean = false;
  @Input() agentEmail: boolean = false;
  @Input() agentCompnay: boolean = false;
  @Input() isValueName: boolean = false;
  @Input() searchKey: string = 'company';
  @Input() showEmail: boolean = false;
  @Input() showEmailandTenant: boolean = false;
  @Input() tenant: string = '';
  @Input() class: string = '';
  @Input() type: string ='';
  @Input() ID:string=''
  @Input() multiple?: boolean = false;
  @Input() showClear?: boolean = false;
  @Input() showStateCity: boolean = false;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @Output() nextOffsetagent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() agentDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  agentList: any[] = [];
  paginationLimit: number = PaginationLimit.agent;
  totalagentCount: number = 0;
  agentOffset: number = PaginationLimit.agent;
  agentPagination = {
    skip: 0,
    limit: PaginationLimit.agent
  };
  agentFilter: FormControl = new FormControl('');
  isLoading: boolean = false;
  searchValue: BehaviorSubject<string> = new BehaviorSubject('')

  constructor(
    private _cacheAgentService: CacheAgentService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedagent']?.currentValue) {
      const selectedValues = this.multiple
        ? Array.isArray(this.selectedagent) ? this.selectedagent : [this.selectedagent]
        : [this.selectedagent];
  
      setTimeout(() => {
        if (this.agentList.length === 0) {
          this.getagent();
        } else {
          selectedValues.forEach((id: any)=> {
            if (id) this.checkagentExists(id);
          });
        }
      }, 400);
    } else {
      if (this.agentList.length === 0) {
        this.getagent();
      }
    }
  }

  async ngOnInit() {
    console.log(this.showStateCity)
    if (this.multiple && !(this.control.value instanceof Array)) {
      this.control.setValue([]);
    }
  }

  async getagent() {
    await this.loadAgents();
  if (this.selectedagent) {
    const selectedValues = this.multiple
      ? Array.isArray(this.selectedagent) ? this.selectedagent : [this.selectedagent]
      : [this.selectedagent];

    selectedValues.forEach((id: any) => {
      if (id) this.checkagentExists(id);
    });
  }
  }

  valueName(generalDetails?) {
    let value = '';
    if (this.agentEmail) {
      value = `${generalDetails?.email}`
    }
    else if (this.agentName) {
      value = `${generalDetails?.firstName} ${generalDetails?.lastName}`
    } else {
      value = `${generalDetails?.company}`
    }
    return value
  }
  valueId(data?) {
    const { generalDetails } = data
    let value = '';
    if (this.agentEmail || this.agentName || this.agentCompnay) {
      value = `${this.valueName(generalDetails)}`
    } else {
      value = `${data?.id}`
    }

    return value
  }

  getSearchKey() {
    this.agentEmail || this.agentName || this.agentCompnay
    if (this.agentEmail) {
      return 'email'
    } else if (this.agentName) {
      return 'name'
    } else {
      return 'company';
    }
  }

  private async loadAgents(filter: string = ''): Promise<void> {
    if (filter) {
      this.agentPagination = {
        skip: 0,
        limit: PaginationLimit.agent
      }
      this.agentList = [];
    }
    try {
      this.isLoading = true;  // Set loading to true before making the API call
      // Fetch universities using the cache service
      const agentData: { data: any[], total: number } = await this._cacheAgentService.fetchAgents(this.agentPagination, filter, this.tenant, this.getSearchKey());
      const agentList = agentData.data.map((v: any) => {
        let displayName = this.valueName(v?.generalDetails);
        const email = v?.generalDetails?.email;
        const tenantName = v?.tenantsDt?.[0]?.general?.tenantName;
        if (this.showEmail) {
          displayName += ` (${email ? email : ''})`;
        } else if (this.showEmailandTenant) {
          const emailPart = email || '';
          const tenantPart = tenantName ? `(${tenantName})` : '';
          displayName += ` - ${emailPart} ${tenantPart}`;
        } else {
          displayName += ` (${tenantName ? tenantName : ''})`;
        }
        if (this.showStateCity) {
          const state = v?.state?.name || '';
          const city = v?.generalDetails.city || '';
          if (state || city) {
            displayName += ` - ${[city,state].filter(Boolean).join(', ')}`;
          }
        }
        return {
          id: this.valueId(v),
          name: displayName,
          tenant: v?.tenantsDt[0]?.general?.tenantName,
          maiId: v?.id
        };
      });
      this.agentList = [...this.agentList, ...agentList];
      // console.log(this.agentList);
      if (this.showAllagent) {
        this.agentList.unshift({
          id: this.ID,
          name: `All ${this.type}`
        })
      }
      this.agentList = [...new Set(this.agentList)];

      this.totalagentCount = agentData.total;

    } catch (error) {
      // Handle any errors while loading the universities
      console.error('Error loading universities:', error);
    } finally {
      this.isLoading = false;  // Reset loading after the API call completes
    }
  }


  private checkagentExists(searchValue: string): void {
    let mainId = searchValue;

    // If email or name is true, find the matching agent and get its maiId
    if (this.agentEmail || this.agentName || this.agentCompnay) {
      // console.log(this.agentList);
      const matchingAgent = this.agentList.find((agent) => {
        return agent.id === searchValue
      }
      );
      if (matchingAgent) {
        mainId = matchingAgent.maiId; // Use the stored main ID
      }
    }

    // Now use mainId to fetch the agent
    if (!this.agentList.some((u) => u.id === searchValue)) {
      this._cacheAgentService.getAgentById(mainId).subscribe({
        next: (agent) => {
          if (agent && agent?.statusCode === 200 && agent?.data) {
            this.agentList.push({
              id: this.valueId(agent?.data),
              name: `${this.valueName(agent?.data?.generalDetails)} ${this.showEmail
                ? `(${agent?.data?.generalDetails?.email})`
                : agent?.tenantsDt && agent?.tenantsDt[0]?.general?.tenantName
                  ? `(${agent?.tenantsDt[0]?.general?.tenantName})`
                  : ''
                }`,
              tenant: agent?.tenantsDt && agent?.tenantsDt[0]?.general?.tenantName
                ? `(${agent?.tenantsDt[0]?.general?.tenantName})`
                : '',
              maiId: agent?.data?.id
            });
          } else {
            console.warn(`agent with ID ${mainId} not found.`);
          }
        },
        error: (err) => console.error('Error fetching agent by ID:', err)
      });
    }
  }

  getNextagent(): void {
    if (this.searchValue?.value) return
    if (this.agentPagination.skip < this.totalagentCount) {
      this.agentPagination.skip += this.paginationLimit;
      this.isLoading = false;
      this.showAllagent =false;
      this.loadAgents(this.agentFilter.value);
    }
  }

  async filteragent(filter: string) {
    this.searchValue.next(filter);
    this.agentList = [];
    await this.loadAgents(filter);
  
    const currentValue = this.control.value;
    if (this.multiple && Array.isArray(currentValue)) {
      currentValue.forEach(id => {
        if (id) this.checkagentExists(id);
      });
    } else if (currentValue) {
      this.checkagentExists(currentValue);
    }
  }
  
  onSelectionChange(event: any) {
    const selectedValue = event.value;
    const value = this.multiple
      ? (Array.isArray(selectedValue) ? selectedValue : [selectedValue])
      : selectedValue;
  
    this.control.setValue(value);
    this.selectionChange.emit(event);
  }
  
}
